import {
  BiColor,
  BiPalette,
  BiVizStyle,
  kBiDefaultPalette,
  kBiPaletteColors,
} from '@euler/model/bi/viz';

/** What each theme color token renders as. */
export const kBiColorValues: Record<BiColor, string> = {
  [BiColor.Blue]: '#3B82F6',
  [BiColor.Sky]: '#0EA5E9',
  [BiColor.Cyan]: '#06B6D4',
  [BiColor.Teal]: '#14B8A6',
  [BiColor.Green]: '#10B981',
  [BiColor.Lime]: '#84CC16',
  [BiColor.Yellow]: '#EAB308',
  [BiColor.Amber]: '#F59E0B',
  [BiColor.Orange]: '#F97316',
  [BiColor.Red]: '#EF4444',
  [BiColor.Rose]: '#F43F5E',
  [BiColor.Pink]: '#EC4899',
  [BiColor.Purple]: '#A855F7',
  [BiColor.Violet]: '#8B5CF6',
  [BiColor.Indigo]: '#6366F1',
  [BiColor.Navy]: '#1E3A8A',
  [BiColor.Slate]: '#64748B',
  [BiColor.Gray]: '#9CA3AF',
  [BiColor.Gold]: '#CA8A04',
  [BiColor.Brown]: '#92400E',
  [BiColor.Olive]: '#6B7F2A',
  [BiColor.Pine]: '#166534',
  [BiColor.Emerald]: '#059669',
  [BiColor.Mint]: '#34D399',
  [BiColor.Lavender]: '#A78BFA',
  [BiColor.Coral]: '#FB7F6B',
  [BiColor.Sage]: '#8FA98F',
  [BiColor.Mauve]: '#B48A9A',
  [BiColor.Mist]: '#8EA9C1',
  [BiColor.Sand]: '#D2B48C',
  [BiColor.Taupe]: '#A38F85',
  [BiColor.Wine]: '#9F1239',
};

/**
 * The palette a card draws with: its own, else its dashboard's. One this
 * build does not know (added after it shipped) draws as the default.
 */
export function biEffectivePalette(
  style: BiVizStyle | undefined,
  dashboardPalette: BiPalette | undefined,
): BiPalette {
  const palette = style?.palette ?? dashboardPalette ?? kBiDefaultPalette;
  return kBiPaletteColors[palette] ? palette : kBiDefaultPalette;
}

/**
 * The color of the `index`-th series (or slice), named `key`: its own
 * color, else its turn in the palette. An own color this build does not
 * know takes the palette's.
 */
export function biSeriesColor(
  style: BiVizStyle | undefined,
  dashboardPalette: BiPalette | undefined,
  key: string,
  index: number,
): string {
  const own = style?.seriesColors?.[key];
  if (own && kBiColorValues[own]) return kBiColorValues[own];
  const colors = kBiPaletteColors[biEffectivePalette(style, dashboardPalette)];
  return kBiColorValues[colors[index % colors.length]];
}
